/**
 * IB PIX send fee quote (overlay only) via MobileService
 * `GET /v1/ib/pix/fee-quote` — account-owner instance catalog (enviado).
 */

import api from "./api";
import { resolveCustomerPixOverlayCents } from "../Utils/computePixOverlayFee";

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const normalizePayer = (value) => {
  const raw = String(value || "customer").trim().toLowerCase();
  return raw === "instance" ? "instance" : "customer";
};

/**
 * @returns {{
 *   feePayer: 'customer'|'instance',
 *   feePercent: number,
 *   feeFixed: number,
 *   taxAmountCents: number,
 *   amountCents: number,
 *   totalDebitCents: number,
 * }}
 */
export const getPixSendFeeQuote = async ({ amountCents, accountId } = {}) => {
  const params = {};
  if (amountCents != null && Number(amountCents) > 0) {
    params.amount = Math.trunc(Number(amountCents));
  }
  if (accountId) {
    params.account_id = accountId;
  }

  const { data } = await api.get("/v1/ib/pix/fee-quote", { params });
  const root = data?.data ?? data;

  const feePayer = normalizePayer(root?.fee_payer ?? root?.feePayer);
  const feePercent =
    toNumber(root?.fee_percent ?? root?.feePercent)
    || toNumber(root?.instance_fee_percent ?? root?.instanceFeePercent);
  const feeFixed =
    toNumber(root?.fee_fixed ?? root?.feeFixed)
    || toNumber(root?.instance_fee_fixed ?? root?.instanceFeeFixed);
  const amount = Math.trunc(toNumber(root?.amount ?? amountCents));
  const taxFromApi = Math.round(toNumber(root?.tax_amount ?? root?.taxAmount));
  const taxAmountCents =
    taxFromApi > 0 || feePayer === "instance"
      ? feePayer === "instance"
        ? 0
        : taxFromApi
      : resolveCustomerPixOverlayCents({
          amountCents: amount,
          feePayer,
          feePercent,
          feeFixed,
        });
  const totalDebitCents =
    Math.round(toNumber(root?.total_debit ?? root?.totalDebit))
    || amount + taxAmountCents;

  return {
    feePayer,
    feePercent,
    feeFixed,
    taxAmountCents,
    amountCents: amount,
    totalDebitCents,
  };
};
